module.exports = __webpack_public_path__ + "static/media/468x60_0005_ru.481fdbfe.png";